import { Grid, CssBaseline } from "@mui/material";
import CalebAndBrownLogo from "src/icons/cnbDesktop";
import { useIsMobile } from "src/utils/hooks/useIsMobile";
import CnbLogoMobile from "src/icons/CnbLogoMobile";
import { LoginStyles } from "src/components/auth/styles/Login.styles";
import GenericMessageModal from "src/components/wallets/Modal/Withdraw/GenericMessageModal";

const PasswordResetError = () => {
  const classes = LoginStyles();
  const isMobile = useIsMobile();
  const message = "Please verify your email address";

  return (
    <div className={classes.container}>
      <CssBaseline />
      <Grid container className={classes.logoBox}>
        {isMobile ? <CnbLogoMobile height={"200px"} /> : <CalebAndBrownLogo />}
      </Grid>
      <Grid container justifyContent="center" style={{ height: "200px", zIndex: 10000 }}>
        <GenericMessageModal customMessage={message} hideButton halfSize />
      </Grid>
    </div>
  );
};

export default PasswordResetError;
